/**
 * Calculates the ratio between scrollable area movement & scroll bar movement
 * @param {number} scrollableLength - total length of the overflowed content
 * @param {number} maxLength - maximum visible length for the overflowed content
 */
export const calcOffsetRatio = (scrollableLength, maxLength, grabberLength) =>
    scrollableLength
        ? (scrollableLength - maxLength) / (maxLength - grabberLength)
        : 1;

/**
 * Updates the scrollbar position as-well-as the overflow's position
 * @param {number} pos - Scrollbar position
 * @param {number} offsetRatio - ratio between scrollable area movement & scroll bar movement
 */
export const updatePos = (pos, offsetRatio) =>
    pos && pos > 0 && offsetRatio > 0 ? pos * offsetRatio : 0;
